import React from 'react';
import {Switch} from '@bonprix/design-system';

export default function Toggle({label, checked, onChange}) {
    return (
        <div className="mt-3 mb-7">
            <Switch label={label} checked={checked} onChange={onChange} />
        </div>
    );
}
